import { useLocation } from "react-router-dom";

export default function ForbiddenPage() {
    const location = useLocation();

    const reason: string = location.state?.reason || 'unauthorized'; 
    const isLocked: boolean = reason === 'locked';
    
    return (<>
        <div className="p-5 text-center">
            <img src="/assets/403.png" alt="403 - Access denied" className="max-w-md mx-auto mb-4"  width={200}/>
            <h1 className="text-4xl mb-3">403 - Access denied</h1>
            {isLocked && <><p className="mb-4">The administrator has blocked you from accessing this web site.</p></>}

            {!isLocked && <><p className="mb-4">You don’t have permission to view this page.</p>
                <button className="p-button" onClick={() => window.location.href = '/'}>Go to home page</button></>
            }
        </div>
    </>);
}
